import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { sidebarStatePropType } from 'components/Sidebar/propTypes';
import { selectOptionsFromServer } from '../selectors';
import { QUESTION_VIEW_TYPES } from '../constants/questionViewTypes';
import { completeGroupedOptions } from '../functions/completeGroupedOptions';
import { MultipleOptionQuestionView } from './MultipleOptionQuestionView';

const { MULTISELECT_WITH_SEARCH } = QUESTION_VIEW_TYPES;

export const ServerMultipleOptionQuestion = ({
  question, sidebarState, value, onChange, shouldNextButtonBeShown, handleNextButtonClick,
}) => {
  const {
    id, title, subtitle, placeholder, viewType = MULTISELECT_WITH_SEARCH, questionProps,
  } = question;

  const { optionsFromServer, disease } = useSelector((state) => ({
    optionsFromServer: selectOptionsFromServer(state),
    disease: state?.profile?.data?.personal?.condition,
  }));

  const {
    groupedOptions,
    groupedOptionsByDiseases,
    topSelectedOptionsByDiseases,
    options: { dropDownOptions, radioOptions } = {},
  } = optionsFromServer[id] ?? {};

  // to prevent nested component logic recalculation
  const completedGroupedOptions = useMemo(() => (
    completeGroupedOptions({
      groupedOptions: groupedOptions ?? groupedOptionsByDiseases?.[disease],
      topSelectedOptions: topSelectedOptionsByDiseases?.[disease],
    })
  ), [disease, groupedOptions, groupedOptionsByDiseases, topSelectedOptionsByDiseases]);

  return (
    <MultipleOptionQuestionView
      id={id}
      values={value ?? []}
      onChange={onChange}
      title={title}
      subtitle={subtitle}
      groupedOptions={completedGroupedOptions}
      dropDownOptions={dropDownOptions}
      radioOptions={radioOptions}
      placeholder={placeholder}
      sidebarState={sidebarState}
      viewType={viewType}
      questionProps={questionProps}
      shouldNextButtonBeShown={shouldNextButtonBeShown}
      handleNextButtonClick={handleNextButtonClick}
    />
  );
};

ServerMultipleOptionQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  sidebarState: sidebarStatePropType,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  shouldNextButtonBeShown: PropTypes.bool.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired,
};
